import { Component, Input } from '@angular/core';
import { Bookmark } from '../../../models/bookmark';
import { ButtonDirective } from 'primeng/button';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-bookmark-button',
  standalone: true,
  imports: [ButtonDirective, RouterLink],
  templateUrl: './bookmark-button.component.html',
  styleUrl: './bookmark-button.component.scss',
})
export class BookmarkButtonComponent {
  @Input() bookmark!: Bookmark;
}
